import React, { useEffect } from 'react'
import { Form } from 'antd'
import FORM_LAYOUT from 'constant/form-layout'
import PropTypes from 'prop-types'
import OrganisationSelect from 'view/component/form-items/attachment-org-select'
import UserTypeSelect from 'view/component/form-items/attachment-user-type-select'
import AttachmentUpload from 'view/component/form-items/attachment-upload'
import formatArticle from 'helper/format-input-fields'

const AttachmentForm = ({ attachment = {}, allowUpload, articleUuid, form }) => {
  const fileName = attachment.file_name && attachment.file_extension ? attachment.file_name + attachment.file_extension : ''

  useEffect(() => {
    form.setFieldsValue(formatArticle(attachment))
  }, [attachment])

  return (
    <Form
      form={form}
      layout={FORM_LAYOUT}
    >
      <AttachmentUpload
        allowUpload={allowUpload}
        fileName={fileName}
      />
      <OrganisationSelect articleUuid={articleUuid} />
      <UserTypeSelect articleUuid={articleUuid} />
    </Form>)
}

AttachmentForm.propTypes = {
  allowUpload: PropTypes.bool,
  articleUuid: PropTypes.string,
  attachment: PropTypes.object,
  form: PropTypes.object
}

export default AttachmentForm
